module.exports = __webpack_public_path__ + "static/media/impacttracking.dd891561.png";